import { createSlice } from "@reduxjs/toolkit";

const formSlice = createSlice({
  name: "form",
  initialState: {
    fromIncidentId: null,
  },
  reducers: {
    saveFromIncidentId: (state, action) => {
      state.fromIncidentId = action.payload;
    },
  },
});

export const { saveFromIncidentId } = formSlice.actions;

export default formSlice.reducer;

export const selectFromIncidentId = (state) => state.form.fromIncidentId;
